import { AppConfig } from '../../app/app.config';

export const ALL_CHANNELS = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.BRANCH,
  AppConfig.Shared.EventTracker.MIXPANEL,
  AppConfig.Shared.EventTracker.AMPLITUDE,
];

export const CHANNELS_EXCLUDING_MIXPANEL = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.BRANCH,
  AppConfig.Shared.EventTracker.AMPLITUDE,
];

export const PRIMARY_CHANNELS = [
  AppConfig.Shared.EventTracker.MOENGAGE,
  AppConfig.Shared.EventTracker.CLEVER_TAP,
  AppConfig.Shared.EventTracker.CURESKIN_METRICS,
  AppConfig.Shared.EventTracker.BRANCH,
];
